import { Link } from "react-router-dom";
import { LOGO, scrollToId } from "@/lib/assets";
import { useLang } from "@/lib/i18n";

const scrollTo = scrollToId;

// Map of link labels (per lang) to their action
// "scroll:id"  → scrollToId(id)
// "route:/path" → <Link to="/path">
// "href:url"    → <a href="url" target="_blank">
const LINK_MAP = {
  en: {
    // PRODUCT
    Squads:          "scroll:modes",
    Vault:           "scroll:modes",
    "Resenha Engine":"scroll:resenha",
    Sports:          "scroll:sports",
    // COMPANY
    Manifesto:       "scroll:manifesto",
    Careers:         "href:mailto:hello@pinwin.social",
    Press:           "href:mailto:hello@pinwin.social",
    Contact:         "href:mailto:hello@pinwin.social",
    // LEGAL
    Privacy:         "route:/privacy",
    Terms:           "route:/terms",
    Cookies:         "route:/privacy",
  },
  es: {
    Squads:          "scroll:modes",
    Vault:           "scroll:modes",
    "Resenha Engine":"scroll:resenha",
    Deportes:        "scroll:sports",
    Manifiesto:      "scroll:manifesto",
    Carreras:        "href:mailto:hello@pinwin.social",
    Prensa:          "href:mailto:hello@pinwin.social",
    Contacto:        "href:mailto:hello@pinwin.social",
    Privacidad:      "route:/privacy",
    Términos:        "route:/terms",
    Cookies:         "route:/privacy",
  },
  pt: {
    Squads:          "scroll:modes",
    Vault:           "scroll:modes",
    "Resenha Engine":"scroll:resenha",
    Esportes:        "scroll:sports",
    Manifesto:       "scroll:manifesto",
    Carreiras:       "href:mailto:hello@pinwin.social",
    Imprensa:        "href:mailto:hello@pinwin.social",
    Contato:         "href:mailto:hello@pinwin.social",
    Privacidade:     "route:/privacy",
    Termos:          "route:/terms",
    Cookies:         "route:/privacy",
  },
};

function FooterLink({ label, action, className }) {
  const cls = className || "font-body text-sm text-white/70 hover:text-[#E6FF00] transition-colors";

  if (!action || action.startsWith("scroll:")) {
    const id = action?.replace("scroll:", "") || null;
    return (
      <button
        onClick={() => id && scrollTo(id)}
        className={cls + " text-left"}
      >
        {label}
      </button>
    );
  }

  if (action.startsWith("route:")) {
    return (
      <Link to={action.replace("route:", "")} className={cls}>
        {label}
      </Link>
    );
  }

  if (action.startsWith("href:")) {
    return (
      <a href={action.replace("href:", "")} className={cls}>
        {label}
      </a>
    );
  }

  return <span className={cls}>{label}</span>;
}

export default function Footer() {
  const { lang, t } = useLang();
  const f = t.footer;
  const map = LINK_MAP[lang] ?? LINK_MAP.en;

  return (
    <footer className="bg-[#0A0A0A]" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-16 md:py-20">
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div>
            <img src={LOGO} alt="PINWIN" className="h-9 w-auto mb-6" />
            <p className="font-anton uppercase text-3xl md:text-4xl leading-[0.9] max-w-md">
              {f.tagPre} <span className="pw-outline-text">{f.tagStrong}</span>
            </p>
            <button
              onClick={() => scrollTo("reserve")}
              data-testid="footer-cta-btn"
              className="mt-8 font-mono-pw uppercase text-xs tracking-[0.15em] border border-[#E6FF00] text-[#E6FF00] px-6 py-3 hover:bg-[#E6FF00] hover:text-black transition-colors"
            >
              {f.cta}
            </button>
          </div>

          <div className="grid grid-cols-3 gap-8">
            {f.cols.map((c) => (
              <div key={c.title}>
                <h4 className="font-mono-pw uppercase text-xs tracking-[0.2em] text-white/40 mb-4">{c.title}</h4>
                <ul className="space-y-3">
                  {c.links.map((l) => (
                    <li key={l}>
                      <FooterLink label={l} action={map[l]} />
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="font-mono-pw uppercase text-[10px] tracking-[0.2em] text-white/30">
            © {new Date().getFullYear()} PINWIN · {f.copyright}
          </p>
          <a
            href="https://lab2513.com.br"
            target="_blank"
            rel="noopener noreferrer"
            className="font-mono-pw uppercase text-[10px] tracking-[0.2em] text-white/40 hover:text-[#E6FF00] transition-colors"
          >
            LAB2513 Tech & Design Studio
          </a>
        </div>
      </div>
    </footer>
  );
}
